import { createFileRoute } from '@tanstack/react-router';

import { DashboardContent } from '@/features/dashboard/components/dashboard-content';

export const Route = createFileRoute('/_authenticated/')({
  component: Dashboard,
});

function Dashboard() {
  return <DashboardContent />;
}
